import { VApp } from 'vuetify/lib/components/VApp';
import { VPagination } from 'vuetify/lib/components/VPagination';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VApp,
    { attrs: { "data-pagination": "" } },
    [
      _c(VPagination, {
        attrs: {
          length: _vm.pagesQuantity,
          "total-visible": _vm.totalVisible,
          circle: "",
        },
        on: { input: _vm.onPageChanged },
        model: {
          value: _vm.page,
          callback: function ($$v) {
            _vm.page = $$v
          },
          expression: "page",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }